import React, { useEffect, useImperativeHandle, useState } from 'react'
import { deleteData, getData, postData, putData } from '../../services/Axios/Axios';
import { ApiUrl } from '../../config/apiConfig';
import { useLoader } from '../../components/loader/loader';
import { confirmAction, formatDate } from '../../utils/utils';
import AddUser from './AddUser';
import EditButton from '../../components/UIElements/EditButton';
import DeleteButton from '../../components/UIElements/DeleteButton';
import messageService from '../../services/message/messageService';
import { CRM_ACCESS, Employee } from '../../models/Employee';
import { sendAccountStatusChangeMail } from '../../functions/accountFunctions';
import { createAdminUserByEmployee } from '../../utils/user-utils';

interface UserTableProps {
  addEditModel: (data?: any) => void
}
export const UsersTable = React.forwardRef((props: UserTableProps, ref) => {
  const { show, hide } = useLoader();
  const [copied, setCopied] = useState(false);
  const [allUsers, setAllUsers] = useState<any>([]);


  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      alert("Copied to clipboard!");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // hide after 2 seconds
    });

  };



  const getAllUsers = async () => {
    const response = await getData(ApiUrl.listAdmins, {}, {
      show,
      hide,
    });

    setAllUsers(response.data)
  }



  useEffect(() => {
    getAllUsers();
  }, []);

  useImperativeHandle(ref, () => ({
    getAllUsers
  }));


  let deleteUser = async (data: any) => {
    const messageServices = messageService();
    messageServices.confirm(`delete this User`, "").then(async (res) => {
      if (res.value) {

        let response = deleteData(ApiUrl.deleteAdmin + data._id);
        if (await response) {
          getAllUsers()
          messageServices.toast(
            "success",
            messageServices.message.deleteSuccess
          );
        }
      }
    })
  }

  const createNewUser = async (candidate: Employee) => {
    try {
      const obj = createAdminUserByEmployee(candidate);

      await Promise.all([
        postData(ApiUrl.createAdmin, obj),
        putData(`${ApiUrl.updateEmployee}${candidate._id}`, {
          crmAccess: CRM_ACCESS.APPROVE
        })
      ]);

      sendAccountStatusChangeMail(
        obj.email,
        obj.name,
        "CONFIRMED",
        obj.password
      );
      
      getAllUsers();
      messageService().toast(
        "success",
        `User created successfully`
      );
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className="w-full overflow-x-auto px-2">
      <table className="min-w-full border-collapse border border-gray-100  overflow-hidden shadow text-center">
        <thead className="whitespace-nowrap">
          <tr className="bg-greenBg text-white whitespace-nowrap">
            <th className="border border-gray-200 p-2">
              S no
            </th>

            <th className="border border-gray-200 p-2">User Name</th>
            <th className="border border-gray-200 p-2">User Type</th>
            <th className="border border-gray-200 p-2">Email Address</th>
            <th className="border border-gray-200 p-2">Phone Number</th>
            <th className="border border-gray-200 p-2">
              Assigned Permissions
            </th>
            <th className="border border-gray-200 p-2">Created At</th>

            <th className="border border-gray-200 p-2">Action</th>
          </tr>
        </thead>
        <tbody className="border border-gray-400 whitespace-nowrap ">

         
          {/* users list */}
          {allUsers.map((user: any, index: number) => <tr key={index} className=" hover:bg-[#f0f0f0]  border border-collapse text-[13px]" >
            <td className="px-2  py-[5px] border border-gray-200">{index + 1}</td>
            <td className="px-2  py-[5px] border border-gray-200">{user.name}</td>
            <td className="px-2  py-[5px] border border-gray-200">{user?.adminType ?? "-"}</td>
            <td className="px-2  py-[5px] border border-gray-200">{user.email}</td>
            <td className="px-2  py-[5px] border border-gray-200">{user.phoneNumber ? user.phoneNumber : "--"}</td>
            <td className="px-2  py-[5px] border border-gray-200">{user.permissions.length} Permissions</td>
            <td className="px-2  py-[5px] border border-gray-200">{formatDate(user.createdAt)}</td>
            <td className="px-2  py-[5px] border border-gray-200">
              <div className="flex justify-center items-center gap-2">
                <EditButton onClick={() => props.addEditModel(user)} />
                <DeleteButton onClick={() => deleteUser(user)} />
              </div>
            </td>
          </tr>)}




        </tbody>
      </table>
    </div>
  )
})

export default UsersTable

